import React      from 'react';
import classnames from 'classnames';

function Steps(props) {
  const list = [
    { id: 1, text: 'Complete form to get instant quote' },
    { id: 2, text: 'Select quantity  & lead time' },
    { id: 3, text: 'Upload gerbers & add to cart' },
  ];
  return (
    <div className="row g-0 quote-steps">
      {list.map(item => (
        <Step
          key={item.id}
          id={item.id}
          text={item.text}
          done={item.id < props.activeItem}
          active={item.id === props.activeItem} />
      ))}
    </div>
  );
}

function Step(props) {
  const cls = classnames({
    col        : true,
    'step-item': true,
    active     : props.active,
    done       : props.done,
  });
  return (
    <div className={cls}>
      <span className="number">{props.id}</span>
      <span>{props.text}</span>
      <span className="arrow" />
    </div>
  );
}

export default Steps;
